import { Toast } from '@zillow/constellation-10';
import type { useToast } from '@zillow/constellation-10';

export async function copyLinkToClipboard(enqueueToast: ReturnType<typeof useToast>['enqueueToast'], link: string) {
  try {
    await navigator.clipboard.writeText(link);
    enqueueToast(
      <Toast id="copy-link-toast-success" tone="success">
        Link copied
      </Toast>,
    );
  } catch {
    enqueueToast(
      <Toast id="copy-link-toast-error" tone="critical">
        Unable to copy link. Please try again.
      </Toast>,
      {
        duration: 10000,
      },
    );
  }
}

export async function shareLinkOnMobile(
  enqueueToast: ReturnType<typeof useToast>['enqueueToast'],
  text: string,
  link: string,
) {
  try {
    await navigator.share({
      text,
      url: link,
    });
  } catch {
    enqueueToast(
      <Toast id="share-link-toast-error" tone="critical">
        Unable to share link.
      </Toast>,
      {
        duration: 10000,
      },
    );
  }
}
